import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-upgrades-search-engine',
  template: require('./linescape-upgrades-search-engine.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-upgrades-search-engine.component.scss')]
})
export class LinescapeUpgradesSearchEngineComponent extends BlogPage {
  title = "Linescape Upgrades Search Engine - Linescape";
  description = "Cutting-edge technology coupled with a new search interface provides more ways to search containership schedules, appealing to a larger shipping community.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-upgrades-search-engine/linescape-upgrades-search-engine.component.ts